import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./styles/mySettingsStyles.css";

// Destructive "Delete my account" card. Replaces the old rails-ujs
// data-confirm browser prompt with a Setlist confirmation modal. Confirming
// submits a real _method=delete form to registrationPath so the server's
// Devise destroy + redirect/flash behavior is unchanged.
const DeleteAccountCard = ({ registrationPath, csrfToken }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!showModal) return undefined;
    const onKeyDown = (e) => { if (e.key === "Escape") setShowModal(false); };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [showModal]);

  const submitDelete = () => {
    const form = document.createElement("form");
    form.method = "post";
    form.action = registrationPath;

    const method = document.createElement("input");
    method.type = "hidden";
    method.name = "_method";
    method.value = "delete";
    form.appendChild(method);

    const token = document.createElement("input");
    token.type = "hidden";
    token.name = "authenticity_token";
    token.value = csrfToken;
    form.appendChild(token);

    document.body.appendChild(form);
    form.submit();
  };

  return (
    <section className="settings-card" data-settings-section id="delete-account">
      <div className="settings-card-header settings-card-header--row">
        <div>
          <h2 className="settings-card-title">Delete my account</h2>
          <p className="settings-card-desc">Once deleted, your account cannot be reinstated.</p>
        </div>
        <button
          type="button"
          className="settings-btn settings-btn-destructive"
          onClick={() => setShowModal(true)}
        >
          Delete account
        </button>
      </div>

      {showModal ? (
        <div className="settings-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="delete-account-title">
          <div className="settings-modal">
            <h3 className="settings-modal-title" id="delete-account-title">Delete your account?</h3>
            <p className="settings-modal-body">
              This permanently deletes your account. Once deleted, it cannot be reinstated.
            </p>
            <div className="settings-modal-actions">
              <button type="button" className="settings-btn settings-btn-secondary" autoFocus onClick={() => setShowModal(false)}>
                Cancel
              </button>
              <button type="button" className="settings-btn settings-btn-error" onClick={submitDelete}>
                Delete account
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
};

DeleteAccountCard.propTypes = {
  registrationPath: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
};

export default DeleteAccountCard;
